module.exports = __webpack_public_path__ + "static/img/VU.658c0cde.png";